import { PendoDraggable as m, shouldCancelDrag as p } from "../directives/draggable/pendo-draggable.js";
const y = {
  directives: {
    PendoDraggable: m
  },
  data() {
    return {
      tableComponentKey: 0,
      draggedTableRow: null,
      sourceUID: null,
      lastMirrorX: null,
      lastMirrorY: null
    };
  },
  watch: {
    "$table.draggable": {
      handler() {
        this.tableComponentKey++;
      }
    }
  },
  methods: {
    mirrorCreateHandler(e) {
      e.cancel();
    },
    dragStartHandler(e) {
      const {
        data: { source: r, sensorEvent: t }
      } = e;
      if (p(t.target))
        return e.cancel();
      const i = document.querySelector("tr[pendo-draggable-mirror='']");
      if (i)
        return i.remove(), e.cancel();
      const a = r.querySelector("td.pendo-table__column--actions .pendo-table__cell");
      for (; a && a.hasChildNodes(); )
        a.removeChild(a.lastChild);
      const s = document.querySelector(`#pendo-table-${this.$table.id}`), { right: d, width: o, bottom: l, height: b } = r.getBoundingClientRect(), g = l - b - t.clientY, u = d - o - t.clientX, n = r.cloneNode(!0);
      n.setAttribute("pendo-draggable-mirror", ""), n.removeAttribute("pendo-draggable-item"), Object.assign(n.style, {
        display: "none",
        position: "fixed",
        pointerEvents: "none",
        top: `${g}px`,
        left: `${u}px`,
        "vertical-align": "middle",
        boxShadow: "0px 10px 16px rgba(0, 0, 0, 0.17)",
        "z-index": "999999"
      }), (n.querySelectorAll("td.pendo-table__column--fixed-left") || []).forEach((c) => {
        Object.assign(c.style, {
          left: `${u - this.$table.scrollStore.scrollLeft}px`
        });
      });
      const h = document.querySelector(`#pendo-table-${this.$table.id} tbody`);
      this.draggedTableRow = {
        id: Array.from(h.querySelectorAll("tr")).findIndex((c) => c.getAttribute("data-uid") === n.getAttribute("data-uid")),
        index: parseInt(n.getAttribute("data-uid"))
      }, this.$table.$emit("table-row-drag-start", { event: e, from: n.getAttribute("data-uid") }), s.appendChild(n);
    },
    dragMoveHandler(e) {
      const {
        data: { sensorEvent: r }
      } = e, t = document.querySelector("tr[pendo-draggable-mirror='']");
      this.$table.clearRowHover(), t && requestAnimationFrame(() => {
        const i = Math.round(r.clientY), a = Math.round(r.clientX);
        this.lastMirrorY = i, this.lastMirrorX = a, t.style.display = "block", t.style.transform = `translate3d(${a}px, ${i}px, 0px)`;
      });
    },
    dragOverHandler(e) {
      const {
        data: { over: r }
      } = e;
      if (!r.classList.contains("pendo-draggable-source--is-dragging")) {
        const t = parseInt(r.getAttribute("data-uid")), i = r.previousElementSibling ? parseInt(r.previousElementSibling.getAttribute("data-uid")) : null, a = r.nextElementSibling ? parseInt(r.nextElementSibling.getAttribute("data-uid")) : null;
        this.sourceUID === null ? this.sourceUID = t : r.previousElementSibling ? r.nextElementSibling ? t === this.sourceUID ? this.sourceUID = i < t ? i : a : this.sourceUID = t : this.sourceUID = this.$table.tableData.length - 1 : this.sourceUID = 0, this.$table.$emit("table-row-drag-over", { event: e, to: this.sourceUID });
      }
    },
    async dragStopHandler(e) {
      const {
        data: { source: r }
      } = e, t = document.querySelector("tr[pendo-draggable-mirror='']");
      if (t) {
        const { x: i, y: a } = r.getBoundingClientRect(), { x: s, y: d } = t.getBoundingClientRect();
        t.addEventListener("transitionend", this.dragTransitionEndHandler.bind(this, { mirror: t })), requestAnimationFrame(() => {
          t.style.transition = "transform 80ms ease-in-out, box-shadow 80ms ease-in-out", t.style.transform = `translate3d(${this.lastMirrorX + i - s}px, ${this.lastMirrorY + a - d}px, 0)`, t.style.boxShadow = "0px 0px 0px rgba(0, 0, 0, 0.17)", setTimeout(() => {
            this.dragTransitionEndHandler({ mirror: t });
          }, 100);
        }), this.draggedTableRow = null;
        const o = t.getAttribute("data-uid");
        if (this.sourceUID !== null && o !== null) {
          const l = this.$table.tableData.slice();
          l.splice(this.sourceUID, 0, l.splice(o, 1)[0]), await this.$table.loadData(l), this.tableComponentKey++;
        }
        this.$table.$emit("table-row-drag-stop", {
          event: e,
          from: o,
          to: this.sourceUID,
          tableData: this.$table.tableData
        });
      }
    },
    dragTransitionEndHandler({ mirror: e }) {
      e && (e.removeEventListener("transitionend", this.dragTransitionEndHandler), e.remove(), this.sourceUID = null, this.lastMirrorY = null, this.lastMirrorX = null);
    }
  }
};
export {
  y as default
};
//# sourceMappingURL=table-draggable.js.map
